/* PARIDHAN size guide - two-way inch/cm conversion.
   Each measurement column declares its SOURCE unit via its header text:
     "Waist (In)"  -> data-sg-from="in"
     "Height (CM)" -> data-sg-from="cm"
   Converted values are rounded to the nearest 0.5. Native values are never altered. */
(function () {
  var IN_TO_CM = 2.54;

  function roundHalf(value) {
    return Math.round(value * 2) / 2;
  }

  function convertText(text, from, to) {
    if (from === to) return text;
    var factor = to === 'cm' ? IN_TO_CM : 1 / IN_TO_CM;
    return text.replace(/\d+(?:\.\d+)?/g, function (match) {
      return String(roundHalf(parseFloat(match) * factor));
    });
  }

  function setUnit(root, unit) {
    var i;
    var cells = root.querySelectorAll('[data-sg-from]');

    for (i = 0; i < cells.length; i++) {
      var cell = cells[i];
      var source = cell.getAttribute('data-sg-src');

      if (source === null) {
        source = cell.textContent.trim();
        cell.setAttribute('data-sg-src', source);
      }

      cell.textContent = convertText(source, cell.getAttribute('data-sg-from'), unit);
    }

    var suffixes = root.querySelectorAll('[data-sg-unit-suffix]');
    for (i = 0; i < suffixes.length; i++) {
      suffixes[i].textContent = unit === 'cm' ? '(cm)' : '(in)';
    }

    var buttons = root.querySelectorAll('[data-sg-unit]');
    for (i = 0; i < buttons.length; i++) {
      var isActive = buttons[i].getAttribute('data-sg-unit') === unit;
      buttons[i].setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }
  }

  function init(root) {
    if (root.getAttribute('data-sg-ready') === 'true') return;
    root.setAttribute('data-sg-ready', 'true');

    root.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var button = target.closest('[data-sg-unit]');
      if (!button || !root.contains(button)) return;

      event.preventDefault();
      setUnit(root, button.getAttribute('data-sg-unit'));
    });

    setUnit(root, root.getAttribute('data-sg-default') || 'in');
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-size-guide]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
